<template>
  <FormulateInput
    v-bind="{ ...$props, ...$attrs }"
    :validation-name="placeholder"
    :placeholder="elementPlaceholder"
  />
</template>

<script>
import requiredLabelMixin from '../requiredLabelMixin';

export default {
  name: 'TextField',
  mixins: [requiredLabelMixin],
  props: {
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    validation: {
      type: [String, Array],
      default: 'required',
    },
  },
};
</script>
